import api from './api';

const _resourceUrl = '/dict';

export type DictionaryKey =
  | 'volume-unit-types' // Справочник единица измерения объема
  | 'oil-product-types' // Справочник тип гсм
  | 'mass-unit-types' // Справочник единица измерения массы
  | 'level-unit-types' // Справочник единица измерения уровня
  | 'kpu-client-types' // Справочник для КПУ тип подключения клиента
  | 'connection-types' // Справочник тип подключения
  | 'parity'
  | 'stop-bits';

export const getDictionary = (key: DictionaryKey): Promise<string[]> => {
  return api.get(`${_resourceUrl}/${key}`);
};
